import React, { useEffect, useState } from "react";

function Archives() {
  const [forms, setForms] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://wyrowingbackend.onrender.com/archives")
      .then((res) => res.json())
      .then((data) => {
        setForms(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading Archives:", err);
        setLoading(false);
      });
  }, []);

  const categories = Object.keys(forms).sort((a, b) => a.localeCompare(b));

  return (
<div className="centered-page">
      <h2 style={{ textAlign: "left" }}>Archives</h2>
      <p>
        The collected history of the crew over the years with documents and stories collected from our alumni.
        If you have any questions or contributions, please contact us at{" "}
        <a href="mailto:friendsofrhsrowing@gmail.com" style={{ color: "rgb(22, 22, 116)" }}>
          friendsofrhsrowing@gmail.com
        </a>
        .
      </p>
      {loading ? (
        <p>Loading archives...</p>
      ) : categories.length === 0 ? (
        <p>No form categories found.</p>
      ) : (
        categories.map((category) => (
          <div key={category} style={{ marginTop: "2.5rem" }}>
            <h4 style={{ fontWeight: "bold", fontSize: "1.2rem", textAlign: "left" }}>{category}</h4>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                      borderBottom: "2px solid #000",
                      padding: "0.5rem",
                    }}
                  >
                    Item  Name
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      borderBottom: "2px solid #000",
                      padding: "0.5rem",
                    }}
                  >
                    Type
                  </th>
                </tr>
              </thead>
              <tbody>
                {forms[category].length === 0 ? (
                  <tr>
                    <td colSpan={2} style={{ padding: "0.5rem", color: "#888" }}>
                      No items in this category.
                    </td>
                  </tr>
                ) : (
                  forms[category].map((form, idx) => (
                    <tr key={idx}>
                      <td
                        style={{
                          padding: "0.5rem",
                          borderBottom: "1px solid #ccc",
                        }}
                      >
                        <a
                          href={form.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "rgb(22, 22, 116)",
                            textDecoration: "none",
                          }}
                        >
                          {form.name}
                        </a>
                      </td>
                      <td
                        style={{
                          padding: "0.5rem",
                          borderBottom: "1px solid #ccc",
                        }}
                      >
                        {form.mimeType.split("/").pop()}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
}

export default Archives;